<script setup>
import Modal from "../../../../../components/ui-components/modal/Modal.vue";
import {ref, defineExpose, getCurrentInstance, onMounted, computed} from "vue";
import { useRouter } from 'vue-router'
import { usePageLoadingStore } from "../../../../../stores/pageLoading";
import adminCorporationService from "@/pages/admin/services/corporation/adminCorporationService";
import jobFairUserService from "@/pages/user/services/jobFair/jobFairUserService";
import adminJoinStateService from "@/pages/admin/services/jobfair/adminJoinStateService";

const router = useRouter();
const loadingStore = usePageLoadingStore()

const baseModal = ref(null);
const resolvePromise = ref(null);

const modalBody = ref(null)

const recruDetail = ref(null);
const intvDays = ref([]); // 면접 가능일


onMounted(()=>{
  setTimeout(()=>{
    baseModal.value.isAdminWrap = true;
  }, 500);
})

// 특별채용관 참가 정보
const recruitmentHallDetail = async (ojfId, userId) => {
  const res = await adminJoinStateService.retrieveEntryByOjfIdAndUserId(ojfId, userId)
  if(res.data.code.toLowerCase() === 'success') {
    recruDetail.value = res.data.result;
    ojfIntvDay(ojfId);
  }
}

// 면접 가능일 조회
const ojfIntvDay = async (ojfId) => {
  await jobFairUserService.ojfIntvDay(ojfId)
    .then( async (res) => {
      if(res.data.code.toLowerCase() === 'success') {
        const result = res.data.result;
        if (result !== null && result !== '') {
          const selectedDays = result.split(',').map(d => d.trim());

          intvDays.value = selectedDays.map(day => ({
            label: day,
            on: false
          }));
        }
      }
    }).catch( (error) =>  {
      console.log(error);
    });
}

// 면접 가능일 전체인지 확인 후 문구 표시
const allDays = computed(() => recruDetail.value.intvAbleDay.split(','))
const isAllSelected = computed(() => (intvDays.value || []).length === allDays.value.length)


const show = () => {
  baseModal.value.open();
  return new Promise((resolve, _) => {
    resolvePromise.value = resolve;
  });
};

const confirm = async () => {
  baseModal.value.close();
  resolvePromise.value(true);
};

const cancel = () => {
  baseModal.value.close();
  resolvePromise.value(false);
};

defineExpose({
  show,
  recruitmentHallDetail,
})
</script>

<template>
  <Modal ref="baseModal">
    <div class="modal-inner xl-size">
      <button class="close" @click="cancel"></button>
      <div class="modal-body">
        <div class="resume-wrap">
          <h2 class="mb-xs">신청정보 보기</h2>
          <div class="table-form">
            <table class="vertical">
              <colgroup>
                <col width="20%" />
                <col />
              </colgroup>
              <tr>
                <th colspan="2">참가신청 정보</th>
              </tr>
              <!-- ella : 참가 목적 숨김 요청 (20250904) -->
<!--              <tr>-->
<!--                <th>참가 목적</th>-->
<!--                <td>{{ recruDetail.joinPurpose }}</td>-->
<!--              </tr>-->
              <tr>
                <th>면접 가능일</th>
                <td class="word-break-all">
                  <span v-if="recruDetail.intvInYn === 'Y' && isAllSelected">
                    전체 일정 가능
                    [{{ recruDetail.intvAbleDay }}]
                  </span>
                  <span v-else-if="recruDetail.intvInYn === 'Y'">{{ recruDetail.intvAbleDay }}</span>
                  <span v-else>면접 일정 조율</span>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
  </Modal>

</template>

<style lang="scss" scoped>
@import "../../../../../assets/scss/theme";
.modal-inner {
  margin-top: 50px;
  .close {
    top: -20px !important;
  }
  .file, .link {
    color: $blue_color;
    cursor: pointer;
  }
  .link {
    color: $blue_color;
    text-decoration: underline;
  }
  .gray-bg {
    background: $gray-thin_color;
    padding: 30px;
  }
  .modal-footer {
    padding: 0 30px;
  }
}
</style>